import { CSSObject } from '@chakra-ui/react';

export const NoResultsText: CSSObject = {
  fontSize: 'sm',
  fontWeight: 'bold',
  color: 'gray.300',
};
